export const ENABLE_PROPOSITIONS = 'enablePropositions';
export const ENABLE_CROSSSELL = 'enableCrossSell';
export const ENABLE_RENEWAL_PROPOSITIONS = 'enableRenewalPropositions';
export const ENABLE_RENEWAL_CROSSSELLPROPOSITIONS = 'enableRenewalCrossSellPropositions';
export const ENABLE_ROADSIDE_PREPAY_OFFER = 'enableRoadsidePrepayOffer';
export const ENABLE_CONTACT_US_INSURANCE_CANCELLATION = 'enableContactUsInsuranceCancellation';
export const DISABLE_INSURANCE_CANCEL_POLICY_BUTTON = 'disableInsuranceCancelPolicyButton';
export const ENABLE_UPDATES_TO_UPGRADE_RSA_FORM = 'enableUpdatesToUpgradeRSAForm';
export const ENABLE_UPDATES_TO_MAKE_A_PAYMENT_FORM = 'enableUpdatesToMakeAPaymentForm';
export const ENABLE_AB_Testing_FATZEBRA = 'enableABTestingFatzebra';
